import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const WS_BASE = `${BACKEND_URL.replace(/^http/, "ws")}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const url = config.url || "";
  const customerToken = localStorage.getItem("aj_customer_token");
  const adminToken = localStorage.getItem("aj_token");
  if (url.startsWith("/shop/")) {
    if (customerToken) config.headers.Authorization = `Bearer ${customerToken}`;
  } else if (adminToken) {
    config.headers.Authorization = `Bearer ${adminToken}`;
  } else if (customerToken && url.startsWith("/products")) {
    // navigation boutique par un client connecté (tarifs de groupe)
    config.headers.Authorization = `Bearer ${customerToken}`;
  }
  return config;
});

export const fileUrl = (path) => (path?.startsWith("http") ? path : `${API}/files/${path}`);

export default api;
